import { gql } from '@apollo/client';


export const GET_ALL_AFFILIATES = gql`
query getAllAffiliates ($pageSize: Int, $pageNumber: Int, $order_by: [affiliates_order_by!] = {}, $search_event: String = "%") {
  affiliates(limit: $pageSize, offset: $pageNumber, order_by: $order_by, where: {a_deleted_at:{_is_null:true},user:{_or:[{u_full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}}) {
    aId: a_id
    aType: a_type
    aOrganization: a_organization
    firstName: a_first_name
    lastName: a_last_name
    emailId: a_email_id
    user {
      uId: u_id
      id: u_id
      affiliateId: u_referral_code
      userFullName: u_full_name
      totalEarnings: u_total_earnings
      isActive: u_is_active
      affiliater_ticket_details
      noOfUsers: user_referred_by_aggregate(where: {user_referred_to:{u_deleted_at:{_is_null:true}}}) {
        aggregate {
          count
        }
      }
    }
  }
  totalAffiliates: affiliates_aggregate(where: {a_deleted_at:{_is_null:true},user:{_or:[{u_full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_AFFILIATES = gql`
query GetAffiliates($limit: Int, $offset: Int, $searchText: String = "%", $referrerId: uuid = null, $aStatus: [String!] = ["Active", "Deactive"], $aType: [String!] = ["Direct", "Indirect", "Both"], $order_by: [affiliate_details_order_by!] = {}) {
  getAffiliates(limit: $limit, offset: $offset, args: {searchText: $searchText,referrerId:$referrerId}, where: {aStatus: {_in: $aStatus}, aType: {_in: $aType}}, order_by: $order_by) {
    aId
    aType
    totalAmount
    directPayout
    emailId
    firstName
    indirectPayout
    lastName
    noOfAffiliates
    noOfUsers
    referralCode
    uId
    userFullName
    aStatus
    aCreatedAt
    aUpdatedAt
    aOrganization
    phoneNumber
  }
}
`;

export const GET_AFFILIATE_BUY_SUBSCRIPTION_COMMISSIONS = gql`
  query GetAffiliateBuySubscriptionCommissions {
    affiliate_buy_subscription_commissions(where: { absc_deleted_at: { _is_null: true } }) {
      absc_affiliate_user_id
      absc_commission_level
      absc_commission_amount
    }
  }
`;

export const GET_AFFILIATE_COUNT = gql`
query GetAffiliateCount($searchText: String! = "%", $aStatus: String = null, $referrerId: uuid = null, $aType: String = null) {
  GetAffiliatesCount(args: {searchText:$searchText, referrerId:$referrerId, aStatus:$aStatus, aType: $aType}) {
    totalCount
  }
}
`;

export const GET_AFFILIATE_COUNT_BY_MARKETING_USER = gql `
query GetAffiliateCountByCreatedById($searchText: String! = "%", $referrerId: uuid = null, $aStatus: String = null, $aType: String = null) {
  GetAffiliatesCount: GetAffiliateCountByCreatedById(args: {searchText:$searchText, referrerId:$referrerId, aStatus:$aStatus, aType: $aType}) {
    totalCount
    createdBy
  }
}
`

export const CREATE_AFFILIATE = gql`
mutation AddAffiliate($firstname: String!, $lastname: String!, $emailid: String!, $referralcode: String!, $referrallink: String!) {
  addAffiliate(firstname: $firstname, lastname: $lastname, emailid: $emailid, referralcode: $referralcode, referrallink: $referrallink) {
    message
  }
}
`;

/** @deprecated Use createAffiliateViaNodeApi — local Hasura may not expose password/phoneNumber on addAffiliate */
export const ADD_AFFILIATE = gql`
mutation AddAffiliate ($firstname: String!, $lastname: String!, $emailid: String!, $referralcode: String, $referrallink: String, $aType: String!, $isVanderbiltNILFund: Boolean!, $referredBy: uuid = null, $organization: String) {
  addAffiliate(firstname: $firstname, lastname: $lastname, emailid: $emailid, referralcode: $referralcode, referrallink: $referrallink, aType: $aType, isVanderbiltNILFund: $isVanderbiltNILFund, referredBy: $referredBy, organization: $organization) {
    message
  }
}
`;

export const DELETE_AFFILIATE = gql`
mutation deleteAffiliateById ($affiliateId: uuid) {
  delete_affiliate_by_id(args: {affiliate_id:$affiliateId}) {
    a_id
    a_deleted_at
    a_email_id
  }
}
`;

export const GET_AFFILIATE_BY_ID = gql`
query getAffiliateById ($affiliateId: uuid!) {
  affiliates_by_pk(a_id: $affiliateId) {
    a_id
    a_first_name
    a_last_name
    a_email_id
    user {
      u_referral_link
    }
  }
}
`;

export const GET_AFFILIATE_BY_ID_DIRECT_INDIRECT = gql`
query getAffiliateById($aId: uuid!) {
  GetAffiliateById(args: {aId: $aId}) {
    aId
    aType
    aStatus
    emailId
    firstName
    lastName
    referredBy
    referralUrl
    referralCode
    referredById
    isSupportVanderbiltNILFund
    aOrganization
    phoneNumber
  }
}
`;

export const GET_AFFILIATE_ROW_BY_PK = gql`
query GetAffiliateRowByPk($aId: uuid!) {
  affiliates_by_pk(a_id: $aId) {
    a_id
    a_organization
    a_referral_url
    a_vanderbilt_nil_fund
    a_phone_number
    user {
      u_id
      u_phone_number
      u_email_id
      u_referral_link
    }
  }
}
`;

export const UPDATE_AFFILIATE = gql`
mutation updateAffiliateById (
  $affiliateId: uuid!,
  $firstName: String!,
  $lastName: String!,
  $emailId: String,
  $organization: String,
  $isActive: Boolean,
  $phoneNumber: String,
) {
  affiliate: update_affiliates_by_pk(
    pk_columns: { a_id:$affiliateId },
    _set: { 
      a_first_name:$firstName,
      a_last_name:$lastName,
      a_email_id:$emailId,
      a_organization:$organization,
      a_phone_number:$phoneNumber,
    }
  ) {
    a_id
    a_first_name
    a_last_name
    a_email_id
    a_organization
    a_type
    a_phone_number
  }

  user: update_user(
    where: { a_id:{_eq:$affiliateId} },
    _set: {
      u_first_name:$firstName,
      u_last_name:$lastName,
      u_email_id:$emailId,
      u_is_active:$isActive,
      u_phone_number:$phoneNumber,
    }
  ) {
    returning {
      u_id
      u_first_name
      u_last_name
      u_email_id
      u_is_active
      a_id
      u_phone_number
    }
  }
}
`;

export const EDIT_AFFILIATE =gql`
mutation EditAffiliate ($input: editAffiliateInput!) {
  editAffiliate(input: $input) {
    message
  }
}
`;

export const AFFILIATE_TYPE = gql`
query AffiliateType {
  affiliate_type {
    type
  }
}
`;

export const AFFILIATE_BY_TYPE = gql`
query AffiliateType($aType: [String!]) {
  affiliate_type(where: {type: {_in: $aType}}) {
    type
  }
}
`;

export const AFFILIATE_PAYOUT_TYPE = gql`
  query AffiliatePayoutType {
    affiliate_payout_status_type(where: {type: {_neq: Not_Applicable}}) {
      type
    }
  }
`;

export const AFFILIATE_TYPE_BOTH = gql`
query AffiliateType {
  affiliate_type(where: {type: {_in: ["Both"]}}) {
    type
  }
}
`;

export const GET_REFERRED_AFFILIATE_ADD = gql`
query GetReferredAffiliateAdd{
  affiliates(where: {a_type: {_in: [Indirect, Both]}, a_deleted_at: {_is_null: true}, user: {u_is_active: {_eq: true}}}) {
    a_email_id
    a_first_name
    a_last_name
    a_id
    a_type
    user {
      u_id
      u_first_name
      u_last_name
      u_full_name
      u_referral_code
    }
  }
}
`;

export const GET_REFERRED_AFFILIATE_EDIT = gql`
query GetReferredAffiliateEdit($aId: uuid!) {
  affiliates(where: {a_type: {_in: [Indirect, Both]}, a_id: {_neq: $aId}}) {
    a_email_id
    a_first_name
    a_last_name
    a_id
    a_type
    user {
      u_id
      u_first_name
      u_last_name
      u_full_name
    }
  }
}
`;

export const GET_AFFILIATE_TRANSACTIONS = gql `
  query AffiliateTransactions($userId: uuid!, $limit: Int, $offset: Int) {
    user_transactions(where: {u_id: {_eq: $userId}}, limit: $limit, offset: $offset, order_by: {ut_created_at: desc}) {
      ut_created_at
      ut_deleted_at
      ut_fund_transfer_date
      ut_id
      ut_invoice_number
      ut_transaction_amount
      ut_transaction_status
      ut_type
      ut_transaction_id
      ut_transaction_date
      ut_payout_status
    }
    user_transactions_aggregate(where: {u_id: {_eq: $userId}}, limit: $limit, offset: $offset) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_REFERRED_AFFILIATES = gql `query GetReferredAffiliates {
  affiliates(where: {a_type: {_in: [Direct, Both]}, a_deleted_at: {_is_null: true}, user: {u_is_active: {_eq: true}}}) {
    a_id
    a_organization
    user {
      u_referral_code
      u_id
      u_first_name
      u_last_name
      u_full_name
      u_email_id
    }
  }
}`;
export const GET_AFFILIATE_USERS = gql`
  query GetAffiliateUsers($affiliateId: uuid!, $limit: Int, $offset: Int) {
    getAffiliateUsers(affiliateId: $affiliateId, limit: $limit, offset: $offset) {
      users {
        uId
        firstName
        lastName
        emailId
        createdAt
        isActive
      }
      aggregate {
        count
      }
    }
  }
`;

export const GET_USERS_BY_AFFILIATE_ID = gql`
  query GetUsersByAffiliateId($affiliateIds: [uuid!]!, $affiliateTextIds: [String!]!) {
    user(
      where: {
        _and: [
          {
            _or: [
              { u_delete_requested: { _eq: false } }
              { u_delete_requested: { _is_null: true } }
            ]
          }
          {
            _or: [
              { u_affiliate_id: { _in: $affiliateIds } }
              { u_direct_affiliate_id: { _in: $affiliateTextIds } }
              { u_indirect_affiliate_id: { _in: $affiliateTextIds } }
            ]
          }
        ]
      }
      order_by: { u_created_at: desc }
    ) {
      u_id
      u_full_name
      u_first_name
      u_last_name
      u_email_id
      u_created_at
      u_is_active
      u_phone_number
    }
  }
`;

export const GET_TOTAL_ASSIGNED_USERS_COUNT = gql`
  query GetTotalAssignedUsersCount {
    user_aggregate(
      where: { u_affiliate_id: { _is_null: false }, u_delete_requested: { _eq: false } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_AFFILIATE_PAYOUTS = gql`
  query GetAffiliatePayouts($affiliateId: uuid!, $limit: Int, $offset: Int) {
    getAffiliatePayouts(affiliateId: $affiliateId, limit: $limit, offset: $offset) {
      payouts {
        payoutId
        amount
        status
        createdAt
        paymentMethod
      }
      aggregate {
        count
      }
    }
  }
`;


